import { FILTER_DISPLAY } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";
import { INFO_GROUP_CONSTANTS } from "../../InfoGroup/constants/InfoGroupConstants";

export const USER_TEMP_CONSTANTS = {
  ADD_PAGE_TITLE: "Agregar plantilla de usuario",
  EDIT_PAGE_TITLE: "Editar plantilla de usuario",
  USER_TEMPLATES_ROUTE: "/user-templates",
  PAGE_TITLE: "Plantillas de usuarios",
  PAGE_USER_TEMP_TITLE_SEARCH: "Consulta plantillas de usuarios",
  GROUPS_TITLE: "Grupos de información",
  USER_TEM_SELECT: "userTemSelect",
  BUTTON: {
    ADD_USER_TEMP_TEXT: "Crear plantilla de usuario",
    TOOLTIP: "Cambiar Grafica",
    TOOLTIP_CANCEL: "Cancelar"
  },
  LABEL: {
    USER_TEMP_NAME: "Nombre de la plantilla*",
    HINT_GROUP: "Escriba el nombre del grupo y presione enter para buscar",
    NO_GROUP_FOUND: "No se encontró ningún grupo",
    SEARCH_GROUP: "Búsqueda de grupo",
    HINT_SEARCH_GROUP: "Seleccione grupos de la lista",
    ADD_GROUP: "Grupos*",
    VISUAL_ELEM: "Elemento visual*",
    USER_TEMP_DESC: "Descripción",
    USER_TEMP_INFO: "Información adicional de la plantilla",
    NAME_GROUP_TEXT: "Nombre grupo: ",
    STATE_GROUP_TEXT: "Estado grupo: ",
    LOAD_MORE_TEXT: "Cargar más opciones"
  },
  DIALOG_MESSAGE: {
    USER_TEMP_NAME_EXIST: "Ya existe una plantilla de usuarios con ese nombre",
    NOT_FOUND_GROUPS: "No se encontraron grupos de información",
    NOT_FOUND_USER_TEMPS: "No se encontraron plantillas de usuario",
    ERROR_SAVE_USER_TEMP: "Ocurrió un error al guardar",
    INFO_GROUP_NOT_FOUND:
      "No se encontró el grupo de información básica. No puede crear plantillas sin este grupo",
    BASIC_INFO_REQUIRED: `El grupo de ${INFO_GROUP_CONSTANTS.INFO_GROUP_BASIC_NAME} es obligatorio`,
    USER_TEMP_USED:
      "La plantilla de usuario no se puede eliminar porque esta siendo usada",
    ERROR_DELETE_ID_NOT_FOUND: "La plantilla de usuario a eliminar no existe",
    USER_TEMP_DELETED: "Plantilla de usuario eliminada",
    EMPTY_USER_TEMP_NAME:
      "El nombre de la plantilla no puede ser unicamente espacios en blanco",
    SAVE_MESSAGE_SUCCESS: "Se ha actualizado de forma exitosa",
    CREATE_INFO_GROUP: "Crear grupo de información"
  },
  INFO_MESSAGE: {
    NO_FIELDS_TO_SHOW_HEADER: "No hay campos para mostrar",
    NO_FIELDS_TO_SHOW_TEXT: "Puede agregar campos con el botón '+' del grupo"
  },
  USER_TEMP_REASON_MODAL: {
    TITLE: "Eliminar plantilla de usuario",
    MESSAGE:
      "Ingrese la razón por la cual va a deshabilitar la plantilla de usuario: "
  },
  RULES_MESSAGE: {
    MIN_ONE_GROUP: "Debe seleccionar al menos un grupo"
  },
  OPTIONS_PANEL: [
    {
      value: "showAddList",
      srcImg: "search-session-temp.png",
      name: "Crear grupo de información"
    }
  ],
  CLOSE_MODAL: "closeModal",
  SHOW_USER_TEMPLATE: "showUserTemplate"
};

export const VISUAL_ELEMENT_TYPE = [
  { label: "Vista clásica", value: "classic" },
  { label: "Vista en pestañas", value: "tabs" },
  { label: "Vista en paneles de expansión", value: "expansion-panels" },
  { label: "Vista en paso a paso", value: "stepper" }
];
export const DOCUMENT_SECONDARY_FILTERS: SecondaryFilter[] = [
  {
    name: "Nombre",
    key: "name",
    avatar: "mdi-form-textbox",
    type: "secondaryFilter",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.INPUT,
    default: true
  },
  {
    name: "Estado",
    key: "status",
    avatar: "mdi-list-status",
    type: "secondaryFilter",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: [
      { name: "Activo", key: "Activo" },
      { name: "Inactivo", key: "Inactivo" }
    ]
  }
];

export const USER_FILTERS_LIST: Filter = {
  mainFilterKey: "users",
  mainFilterName: "Todos",
  avatar: "mdi-animation",
  initial: true,
  secondaryFilters: DOCUMENT_SECONDARY_FILTERS
};
export const USER_TEMP_CHART_NAMES = {
  STATES: "Estado"
};

export const USER_TEMPLATES_ACCESS = {
  GET: "consultar plantillas de usuarios",
  POST: "crear plantillas de usuarios",
  PUT: "modificar plantillas de usuarios",
  DELETE: "eliminar plantillas de usuarios"
};

export const NAME_FIELD = "name";
